// extracted by mini-css-extract-plugin
module.exports = {"get-started-container":"GetStarted_get-started-container__2xIAk","get-started":"GetStarted_get-started__2IaQT","title":"GetStarted_title__2BBJ8","text":"GetStarted_text__3gF4g"};